import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
    name: 'filterNewCasePipe',
    pure: false // true is stateless & faster but will not detect changes; false is dynamic and detects changes in input array
    ,
    standalone: false
})
export class FilterNewCasePipe implements PipeTransform {
    transform(input: any[]): any[] {
        if (!input) {
            return [];
        }
        return input.filter(item => {
            return item.casID;
        });
    }
}